import {
  KEY_LOCATION_DIGITAL_ID,
  KEY_LOCATION_OTHERS_ID,
  isDigitalKeyLocationItem,
  isOthersKeyLocationItem,
  type KeyLocationCatalogItem,
  type PatchPropertyKeyLocationBody,
} from "../services/propertyKeyLocation";

export const KEY_LOCATION_PASSWORD_REQUIRED_MESSAGE =
  "O campo senha é obrigatório quando o local da chave for Chave Digital.";

function findCatalogRow(
  catalog: KeyLocationCatalogItem[] | undefined,
  keyLocationId: number | null
): KeyLocationCatalogItem | undefined {
  if (keyLocationId == null) return undefined;
  return (catalog ?? []).find((item) => item.id === keyLocationId);
}

export function isOthersKeyLocation(
  catalog: KeyLocationCatalogItem[] | undefined,
  keyLocationId: number | null
): boolean {
  if (keyLocationId == null) return false;
  const list = catalog ?? [];
  if (list.length > 0) {
    return isOthersKeyLocationItem(findCatalogRow(list, keyLocationId) ?? {});
  }
  return KEY_LOCATION_OTHERS_ID != null && keyLocationId === KEY_LOCATION_OTHERS_ID;
}

export function isDigitalKeyLocation(
  catalog: KeyLocationCatalogItem[] | undefined,
  keyLocationId: number | null
): boolean {
  if (keyLocationId == null) return false;
  const list = catalog ?? [];
  if (list.length > 0) {
    return isDigitalKeyLocationItem(findCatalogRow(list, keyLocationId) ?? {});
  }
  return (
    KEY_LOCATION_DIGITAL_ID != null && keyLocationId === KEY_LOCATION_DIGITAL_ID
  );
}

export function validateKeyLocationNoteForOthers(
  catalog: KeyLocationCatalogItem[],
  keyLocationId: number | null,
  note: string | null | undefined
): string | null {
  if (!isOthersKeyLocation(catalog, keyLocationId)) return null;
  const trimmed = (note ?? "").trim();
  if (trimmed === "") {
    return 'Informe a observação da chave quando a opção é "Outros".';
  }
  if (trimmed.length > 255) {
    return "Observação da chave: máximo de 255 caracteres.";
  }
  return null;
}

export function validateKeyLocationPasswordForDigital(
  catalog: KeyLocationCatalogItem[],
  keyLocationId: number | null,
  password: string | null | undefined,
  options: { allowBlankToKeep?: boolean } = {}
): string | null {
  if (!isDigitalKeyLocation(catalog, keyLocationId)) return null;
  if ((password ?? "").trim() !== "") return null;
  if (options.allowBlankToKeep) return null;
  return KEY_LOCATION_PASSWORD_REQUIRED_MESSAGE;
}

export function buildKeyLocationPatchBody(
  catalog: KeyLocationCatalogItem[],
  input: {
    keyLocationId: number | null;
    keyLocationNote?: string | null;
    keyLocationPassword?: string | null;
  }
): PatchPropertyKeyLocationBody {
  const body: PatchPropertyKeyLocationBody = {
    key_location_id: input.keyLocationId,
    key_location_note: isOthersKeyLocation(catalog, input.keyLocationId)
      ? (input.keyLocationNote ?? "").trim() || null
      : null,
  };

  if (isDigitalKeyLocation(catalog, input.keyLocationId)) {
    const password = (input.keyLocationPassword ?? "").trim();
    if (password !== "") {
      body.key_location_password = password;
    }
  }

  return body;
}

export function applyKeyLocationToCreatePayload(
  payload: Record<string, unknown>,
  catalog: KeyLocationCatalogItem[]
): Record<string, unknown> {
  const keyLocationId =
    payload.key_location_id != null ? Number(payload.key_location_id) : null;
  const next: Record<string, unknown> = { ...payload };
  delete next.key_location;
  next.key_location_id = Number.isFinite(keyLocationId) ? keyLocationId : null;
  next.key_location_note = isOthersKeyLocation(catalog, keyLocationId)
    ? String(payload.key_location_note ?? "").trim() || null
    : null;

  const password = String(payload.key_location_password ?? "").trim();
  if (isDigitalKeyLocation(catalog, keyLocationId) && password !== "") {
    next.key_location_password = password;
  } else {
    delete next.key_location_password;
  }

  return next;
}
